import { proxy, useSnapshot } from 'valtio';

import type {
  ReleaseActivityFeedFilterArgs,
  ReleaseActivityFeedHookQuery,
} from '@graphql/reactQuery';

export type Activity = NonNullable<
  NonNullable<ReleaseActivityFeedHookQuery['releaseActivityFeed']>['edges'][number]['node']
>;

export const TAB_CHOICES = {
  DETAILS: 'details',
  ACTIVITY: 'activity',
  AUDIENCE: 'audience',
  COMMENTS: 'comments',
  OVERVIEW: 'overview',
} as const;

export type TabChoice = (typeof TAB_CHOICES)[keyof typeof TAB_CHOICES];

export const isTabChoice = (v?: string) => !!v && Object.values<string>(TAB_CHOICES).includes(v);

type ActivityState = {
  scrollIndices: Record<string, number | undefined>;
  filter: Record<string, ReleaseActivityFeedFilterArgs>;
};

const initialState: ActivityState = {
  scrollIndices: {},
  filter: {},
};

// Keep track of state per release
export const ReleaseActivityState: ActivityState = proxy(initialState);

export const useReleaseActivityState = () => useSnapshot(ReleaseActivityState);
